<template>
  <div :class="{english:lang=='EN'}">
    <div class="hidden-xs">
      <div class="solution" ref="solution">
        <div class="wow animated fadeInUp" style="display:flex;align-items: center;flex-direction: column;">
          <div class="solution-title">{{$t(title)}}</div>
        </div>
        <div class="wrapper">
          <div class="ul" id="solutionsUl">
            <div class="item" v-for="(item,index) in tabItems"
                 :key="item.tab"
                 :class="{'active-item':item.tab != '' && item.tab != 'medical'}"
                 @mouseenter="showImgActive(item)"
                 @mouseleave="showImg(item)"
                 @click="clickTab(item.tab)"
                 v-show="index < 6 || isShowAllDom"
            >
              <div class="header">
                <span>{{$t(item.title)}}</span>
                <img :src="item.img" alt="">
              </div>
              <div class="content">
                {{$t(item.introduction)}}
              </div>
              <div class="footer" v-if="item.isHasedBtn">
                {{$t('common.learnMore')}}

                <span style="font-size: 1.2rem;">→</span>
              </div>
            </div>
          <div class="more-solutions">
              <span @click="showAllSolutions">{{$t('home.moreSolution')}}
                <i v-if="!isShowAll" class="el-icon-arrow-down"></i>
                <i v-else class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="visible-xs">
      <div class="solution" ref="solution">
        <div class="wow animated fadeInUp" style="display:flex;align-items: center;flex-direction: column;">
          <div class="solution-title">{{$t(title)}}</div>
        </div>
        <div class="wrapper">
          <div class="ul">
            <div class="item" v-for="item in tabItems"
                 :key="item.tab"
                 :class="{'active-item':item.tab != 'port' && item.tab != 'medical'}"
                 @touchstart="showImgActive(item)"
                 @touchend="showImg(item)"
                 @click="clickTab(item.tab)"
            >
              <div class="header" :class="{active:item.tab=='traffic'||item.tab=='park'}">
                <span>{{$t(item.title)}}</span>
                <img :src="item.img" alt="">
              </div>
              <div class="content">
                {{$t(item.introduction)}}
              </div>

<!--              <div class="footer" v-if="item.isHasedBtn">-->
<!--                了解更多-->
<!--                <span style="font-size: 1.2rem;">→</span>-->
<!--              </div>-->
            </div>
            <div class="more-solutions">
              <span @click="showAllSolutions">{{$t('home.moreSolution')}}
                <i v-if="!isShowAll" class="el-icon-arrow-down"></i>
                <i v-else class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs'
  import {mapGetters} from 'vuex'

  export default {
    name: 'MainSolution',
    data() {
      return {
        title: 'home.solution',
        curTab: 'medical',
        curHoverTab: '',
        tabItems: [
          {
            tab: 'airPort',
            title: 'home.airport',
            img: require('../../../assets/img/mainpage/airport1.png'),
            iconPath: require('../../../assets/img/mainpage/airport1.png'),
            iconActivePath: require('../../../assets/img/mainpage/airport2.png'),
            introduction: 'home.apron',
            isHasedBtn: true
          },
           {
            tab: 'education',
            title: 'home.education',
            img: require('../../../assets/img/mainpage/education1.png'),
            iconPath: require('../../../assets/img/mainpage/education1.png'),
            iconActivePath: require('../../../assets/img/mainpage/education2.png'),
            introduction: 'home.message3',
            isHasedBtn: true
          },
          // {
          //   tab: 'park',
          //   title: 'home.park',
          //   img: require('../../../assets/img/mainpage/campus1.png'),
          //   iconPath: require('../../../assets/img/mainpage/campus1.png'),
          //   iconActivePath: require('../../../assets/img/mainpage/campus2.png'),
          //   introduction: 'home.message2',
          //   isHasedBtn: true
          // },
          // {
          //   tab: 'detection',
          //   title: 'home.detection',
          //   img: require('../../../assets/img/mainpage/search1.png'),
          //   iconPath: require('../../../assets/img/mainpage/search1.png'),
          //   iconActivePath: require('../../../assets/img/mainpage/search2.png'),
          //   introduction: 'home.message5',
          //   isHasedBtn: true
          // },
          {
            tab: 'traffic',
            title: 'home.traffic',
            img: require('../../../assets/img/mainpage/001huoche-1-01.png'),
            iconPath: require('../../../assets/img/mainpage/001huoche-1-01.png'),
            iconActivePath: require('../../../assets/img/mainpage/001huoche-1-03.png'),
            introduction: 'home.message11',
            isHasedBtn: true
          },
          // {
          //   tab: 'port',
          //   title: 'home.medical',
          //   img: require('../../../assets/img/mainpage/medical1.png'),
          //   iconPath: require('../../../assets/img/mainpage/medical1.png'),
          //   iconActivePath: require('../../../assets/img/mainpage/medical2.png'),
          //   introduction: 'home.message4',
          //   isHasedBtn: false
          // },
          {
            tab: 'port',
            title: 'home.port',
            img: require('../../../assets/img/mainpage/port1.png'),
            iconPath: require('../../../assets/img/mainpage/port1.png'),
            iconActivePath: require('../../../assets/img/mainpage/port2.png'),
            introduction: 'home.message6',
            isHasedBtn: false
          }
        ],
        isShowAll: false,
        isShowAllDom: false
      }
    },
    methods: {
      showImg(item) {
        if (item.tab !== '' && item.tab !== 'medical') {
          item.img = item.iconPath
        }
      },
      showImgActive(item) {
        if (item.tab !== '' && item.tab !== 'medical') {
          item.img = item.iconActivePath
        }
      },
      clickTab(id) {
        if (id == '' || id == 'medical') {
          return
        }
        this.$router.push({
          name: id,
        })
      },
      showAllSolutions() {
        this.isShowAll = !this.isShowAll
        if (this.isShowAll) {
          $('#solutionsUl').addClass('ul-open')
          this.isShowAllDom = this.isShowAll
        } else {
          $('#solutionsUl').removeClass('ul-open')
          setTimeout(() => {
            this.isShowAllDom = this.isShowAll
          }, 230)
        }
      }
    },
    mounted() {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: false,
        live: false
      })
      wow.init()
    },
    computed: {
      ...mapGetters([
        'lang'
      ])
    }
  }
</script>

<style lang="scss" scoped>
  .solution {
    position: relative;
    width: 100%;
    background: #F3F6FB;


    .solution-title {
      font-size: 3rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(63, 74, 93, 1);
      line-height: 4.38rem;
      letter-spacing: 0.25rem;
      padding-top:7.5rem;
    }

    .wrapper {
      display: flex;
      justify-content: center;
      width: 100%;
      height: auto;
      padding: 6.25rem 0 4.45rem 0;

      .more-solutions {
        width: 100%;
        text-align: center;
        margin-top: 2rem;
        cursor: pointer;

        span {
          color: #3F4A5D;
          font-size: 1.13rem;
          font-weight: 400;
        }
      }
    }

    .ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      max-width: 75rem;
      // height: 34.1rem;
      transition: height .24s ease-out;

      .item {
        width: 24rem;
        height: 14rem;
        padding: 2rem;
        box-shadow: 0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.06);
        position: relative;
        margin-bottom: 1.25rem;
        top: 0;
        transition: top .3s linear;
        -moz-transition: top .3s linear;
        -webkit-transition: top .3s linear;
        -o-transition: top .3s linear;
        &:last-child{
          opacity: 0;
        }
        .header {
          width: 100%;
          height: 4rem;
          position: relative;

          span {
            font-size: 1.5rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
            position: absolute;
            bottom: 0;
          }

          img {
            height: 4rem;
            width: 4rem;
            float: right;
          }
        }

        .content {
          margin-top: 2rem;
          font-size: 0.88rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 300;
          color: rgba(138, 152, 178, 1);
          line-height: 1.25rem;
        }

        .footer {
          position: absolute;
          bottom: 0;
          right: 2rem;
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 300;
          line-height: 4.38rem;
          display: none;
        }
      }

      .active-item:hover {
        top: -0.3rem;
        box-shadow: 0 0 2rem rgba(0, 0, 0, 0.2);
        cursor: pointer;

        .footer {
          color: #2B9EFF;
          display: block;
        }
      }

      .active-item:after {
        content: '';
        width: 0;
        height: 2px;
        background-color: #108CEE;
        position: absolute;
        bottom: 0;
        left: 0.1rem;
        transition: width 1s ease;
        -moz-transition: width 1s ease;
        -webkit-transition: width 1s ease;
        -o-transition: width 1s ease;
      }

      .active-item:hover:after {
        content: '';
        width: 100%;
        height: 2px;
        background-color: #108CEE;
        position: absolute;
        bottom: 0;
        left: 0.1rem;
        transition: width 1s ease;
        -moz-transition: width 1s ease;
        -webkit-transition: width 1s ease;
        -o-transition: width 1s ease;
      }
    }

    .ul-open {
      height: 49.35rem;
    }
  }

  .visible-xs {
    .solution {
      .solution-title {
        font-size: 1.5rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: rgba(63, 74, 93, 1);
        line-height: 4.38rem;
        letter-spacing: 0.25rem;
        padding-top: 2rem;
      }

      .wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
        height: auto;
        padding: 0;
      }

      .ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        max-width: 94%;
        margin: 1rem 0 2rem 0;

        .item {
          width: 48.5%;
          height: 7rem;
          padding: 1rem;
          box-shadow: 0rem 0rem 1rem 0rem rgba(0, 0, 0, 0.06);
          position: relative;
          margin-bottom: 1rem;
          top: 0;
          transition: top .3s linear;
          -moz-transition: top .3s linear;
          -webkit-transition: top .3s linear;
          -o-transition: top .3s linear;

          .header {
            width: 100%;
            height: 2rem;
            position: relative;

            span {
              font-size: 1rem;
              font-family: Arial, Source Han Sans CN;
              font-weight: 400;
              color: rgba(63, 74, 93, 1);
              position: absolute;
              bottom: 0;
            }

            img {
              height: 2rem;
              width: 2rem;
              float: right;
            }
          }

          .content {
            margin-top: 1rem;
            font-size: 0.6rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            color: rgba(138, 152, 178, 1);
            line-height: 1.25rem;
          }

          .footer {
            position: absolute;
            bottom: 0;
            right: 1rem;
            font-size: 0.8rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            line-height: 2rem;
            display: none;
          }
        }

        .active-item:hover {
          top: -0.2rem;
          box-shadow: 0 0 2rem rgba(0, 0, 0, 0.2);
          cursor: pointer;

          .footer {
            color: #2B9EFF;
            display: block;
          }
        }

        .active-item:after {
          content: '';
          width: 0;
          height: 2px;
          background-color: #108CEE;
          position: absolute;
          bottom: 0;
          left: 0rem;
          transition: width 1s ease;
          -moz-transition: width 1s ease;
          -webkit-transition: width 1s ease;
          -o-transition: width 1s ease;
        }

        .active-item:hover:after {
          content: '';
          width: 100%;
          height: 2px;
          background-color: #108CEE;
          position: absolute;
          bottom: 0;
          left: 0rem;
          transition: width 1s ease;
          -moz-transition: width 1s ease;
          -webkit-transition: width 1s ease;
          -o-transition: width 1s ease;
        }
      }
    }
  }

  .english {
    .solution .ul .item .header span{
      font-size: 1.5rem;
    }
    .solution .ul .item .content{
      margin-top:1rem;
      line-height: 1.31rem;
    }
    .solution-title {
      letter-spacing: 0 !important;
    }
    .solution .ul .item .header span{
      top: 50%;
      transform: translate(0,-50%);
    }
    .visible-xs {
      .wrapper {
        .header {
          &.active{
            span{
              top:30%;
            }
          }
          span {
            font-size: 0.8rem !important;
            white-space: pre-wrap;
          }
        }
        .item {
          height:8.5rem;
        }
        .content {
          margin-top:1rem !important;
          font-size: 0.6rem !important;
          line-height: 1.1rem !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/home/MainSolution.vue